<template>
  <div ref="trackingCollapsibleElement">
    <Collapsible
      class="tracking__part tracking-collapsible"
      :isCollapsed="true"
      :maxHeight="185"
      @toggle="onToggle"
    >
      <template #header v-if="trackingCollapsibleHeight > minHeightToCollapse">
        <div
          class="collapsible__header-wrapper"
          :class="isCollapsed ? 'collapsible__background-image' : ''"
        >
          <div class="collapsible__header-content">
            <span> {{ isCollapsed ? 'Show more' : 'Show less' }}</span>
            <UpDownArrow :type="isCollapsed ? 'down' : 'up'" />
          </div>
        </div>
      </template>
      <template #body>
        <slot></slot>
      </template>
    </Collapsible>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, Ref } from 'vue'
import Collapsible from '@/ui-kits/Collapsible.vue'
import UpDownArrow from '../../ui-kits/UpDownArrow.vue'

const trackingCollapsibleElement: Ref<HTMLElement | null> = ref(null)
const trackingCollapsibleHeight = ref(0)
const minHeightToCollapse = 300
const isCollapsed = ref(true)

onMounted(() => {
  if (!trackingCollapsibleElement.value) return
  trackingCollapsibleHeight.value =
    trackingCollapsibleElement.value?.offsetHeight
})

function onToggle(isCollapsedInput: boolean) {
  isCollapsed.value = isCollapsedInput
}
</script>

<style lang="scss">
.tracking-collapsible {
  .collapsible {
    &__header {
      position: absolute;
      bottom: 0;
      width: calc(100% - 2em);
    }
    &__header-wrapper {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      width: 100%;
      padding-bottom: 0.7em;
      z-index: 1;
    }
    &__header-content {
      display: flex;
      align-items: center;
      text-decoration: underline;
      gap: 0.5em;
    }
    &__background-image {
      background-image: linear-gradient(
        0deg,
        var(--order-tracking-background),
        rgba(239, 239, 239, 0)
      );
    }
  }
}
</style>
